export default __webpack_public_path__ + "static/media/Punto_00_Darsena_Nuova_DEU_Def.7f5aef5b.aac";